import { Component } from '@angular/core';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
//import { initFlowbite } from 'flowbite';

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.css'],
})
export class ProfilComponent {
  activeTab: string = 'infos';

  user: any;
  nom: any;
  profil: any;
  role: any;

  changeTab(tab: string) {
    this.activeTab = tab;
  }
  ngOnInit(): void {
    this.user = sessionStorage.getItem('user');
    this.profil = JSON.parse(this.user).profile.id;
    this.role = JSON.parse(this.user).roles[0].id;
  }

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'COMPTE' },
    { label: 'MON PROFIL', url: '/dashboard/users/profil' }
  ];
}
